define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def",
	"csi/def/Field",
	"csi/comm",
	"csi/form/Widget",
	"csi/xml"
], function(array,declare,lang,csi,def,Field,comm,Widget,xml) {
	return declare(Widget, {
		// Field ID's
		FIELD_CREATE_MULTIPLE_ISSUES : "CreateOneIssuePerColorSize",
		FIELD_PRODUCT_COLORS : "IssueProductColors",
		FIELD_PRODUCT_SIZES : "IssueProductSizes",

		_isCreatingMultipleProductIssues: function() {
			var fd = this.defView.m_formData;
			var createIssuePerColorSize = fd.getFieldValue(this.FIELD_CREATE_MULTIPLE_ISSUES, true);
			var urlColors = fd.getFieldValue(this.FIELD_PRODUCT_COLORS) || [];
			var urlSizes = fd.getFieldValue(this.FIELD_PRODUCT_SIZES) || [];

			return createIssuePerColorSize && (urlColors.length > 1 || urlSizes.length > 1);
		},

		toWriterIssues: function(/*Controller*/ac) {
			// summary: for Product, write issues for each ProductColor/ ProductSize combination (S10942)
			// return: array of url of the new Issues
			var fd = this.defView.m_formData;
			var urlColors = fd.getFieldValue(this.FIELD_PRODUCT_COLORS, true) || [];
			var urlSizes = fd.getFieldValue(this.FIELD_PRODUCT_SIZES, true) || [];

			if(urlColors.length == 0)
				urlColors = [csi.EMPTY_URL];
			if(urlSizes.length == 0)
				urlSizes = [csi.EMPTY_URL];

			var	issues = [];

			array.forEach(urlColors, function(color) {
				array.forEach(urlSizes, function(size) {
					issues.push(this._toWriterProductIssue(ac, color, size));
				}, this);
			}, this);

			ac.m_writer.changeParent(ac.m_urlParent, ac.m_idAttrParent, xml.ATTR_REFLIST, issues, true);
			ac.m_writer.validateNode(ac.m_urlParent, true);

			return issues;
		},

		_toWriterProductIssue: function(/*Controller*/ac, /*String*/urlProductColor, /*String*/urlProductSize) {
			// summary: create one Product Issue of selected color/sizes
			// return: url of the new Issue
			var	writer = ac.m_writer;
			var	fd = this.defView.m_formData;
			var	type = "Issue";

			var	name = fd.getFieldValue(xml.ATTR_NAME, true);
			var	url = comm.createUrl(type);
			var	cn = writer.createNode(url, type, name);
			ac.toWriterFields(url, fd);

			if (xml.isValidURL(urlProductColor))
				cn.changeAttribute("IssueProductColors", xml.ATTR_REFLIST, [urlProductColor]);

			if (xml.isValidURL(urlProductSize))
				cn.changeAttribute("IssueProductSizes", xml.ATTR_REFVECTOR, [urlProductSize]);

			writer.validateNode(url, true);

			return url;
		},

		_getProductUrl : function() {
			// If Issue is created under a Product, return URL of the Product, otherwise, return null
			var ac = this.defView.getSource();
			if (!ac)
				return null;

			var issueLog = ac.getParent();
			return issueLog ? issueLog.IssueProduct : null;
		},

		_resolveView : function() {
			// TA27474: When creating Issue for Product, add Color and Size multi-select fields to the create form.
			var params = {addItemAll:true};
			var urlProduct = this._getProductUrl();
			if (xml.isValidURL(urlProduct)) {
				this.insertField(lang.mixin(new Field(), {
					m_id: this.FIELD_PRODUCT_COLORS,
					widgetParams: params
				}));

				this.insertField(lang.mixin(new Field(), {
					m_id: this.FIELD_PRODUCT_SIZES,
					widgetParams: params
				}));

				if(this.defView.getSource().m_action.m_id == "NewIssue") {
					this.insertField(lang.mixin(new Field(), {
						m_label: this.FIELD_CREATE_MULTIPLE_ISSUES,
						m_typeControl: def.FIELD_CHECKBOX
					}));
				}
			}

			this.inherited(arguments);
		}
	});
});
